import React, { Component } from "react";
import BsySelectCheckBox from "../BsySelectCheckBox";
import BsyDialog from "../BsyDialog";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyAlertMenu from "../BsyAlertMenu";

class AddProjectContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userSelectType: 2,
      installTime: 1,
      appIds: [],
      appsMap: {},
      usersManagement: [],
      timeType: "days",
    };
  }

  componentDidMount() {
    this.props.getContext(this);
    React.axios("/dashboard/standardapp_group/list").then((res) => {
      let appsMap = {};
      res.data.items.map((item) => {
        item.apps.map((app) => {
          appsMap[app._id] = app;
        });
      });
      this.setState({ appsMap });
    });
  }

  getContext = () => {
    return this;
  };

  addProjectName = "";
  addProjectDesc = "";

  addChangeProjectName = (e) => {
    this.addProjectName = e.target.value.replace(/\s+/g, " ");
    // e.target.value = this.addProjectName;
  };

  addChangeProjectDesc = (e) => {
    this.addProjectDesc = e.target.value.replace(/[\r\n]/g, "");
    e.target.value = this.addProjectDesc;
  };

  openSelectAppPane = () => {
    let appsEl = null;
    BsyDialog({
      title: React.language("select.release.app"),
      height: 575,
      width: 800,
      customCls: "bsy-app-export-pane",
      okText: React.language("ok"),
      cancelText: React.language("cancel"),
      onContentCreate: (ref) => {
        setTimeout(() => {
          appsEl = new window.FX.AppExportPane({
            renderEl: window
              .$("<div/>")
              .appendTo(
                ref.element.current.getElementsByClassName("dialog-body")[0]
              ),
            isStandard: !0,
            value: {
              app: this.state.appIds,
            },
            onStopEdit: function (e) {
              var label = this.onChangeLabel();
            },
          });
        }, 300);
      },
      onOk: () => {
        this.setState({ appIds: appsEl.value.app });
      },
    });
  };

  selectTime = (event) => {
    const e = event.currentTarget;
    const menu = [
      {
        text: React.language("days"),
        colorType: "",
        click: () => {
          this.setState({ timeType: "days" });
        },
      },
      {
        text: React.language("month"),
        colorType: "",
        click: () => {
          this.setState({ timeType: "month" });
        },
      },
      {
        text: React.language("year"),
        colorType: "",
        click: () => {
          this.setState({ timeType: "year" });
        },
      },
    ];
    e.classList.add("select");
    BsyAlertMenu({
      item: menu,
      width: 160,
      target: event.target,
      customCls: "import-export-item",
      onClose: () => {
        e.classList.remove("select");
      },
    });
  };

  addDocLink = "";

  addChangeDocLink = (e) => {
    this.addDocLink = e.target.value.replace(/\s+/g, " ");
    e.target.value = this.addDocLink;
  };

  addChangeDateTime = (e) => {
    this.addDateTime = e.target.value.replace(/\s+/g, " ");
    e.target.value = this.addDateTime;
  };

  render() {
    const { userSelectType, installTime, appIds, timeType, appsMap } =
      this.state;
    return (
      <div className={"addProjectContent"} style={{ padding: "0 0 20px" }}>
        <div className="projectTitle">
          {React.language("project.info.enter")}
        </div>
        <div className="addItem name">
          <div className="itemTitle">
            <span>
              <b>*</b>
              {React.language("project.name")}
            </span>
          </div>
          <div className="itemValue">
            <input
              autoFocus={true}
              type="text"
              onBlur={this.addChangeProjectName}
              maxLength={128}
              // onChange={this.addChangeProjectName}
              placeholder={React.language("project.name.placeholder")}
            />
          </div>
        </div>
        {/*<div className="addItem link">*/}
        {/*  <div className="itemTitle">*/}
        {/*    <span>{React.language('doc.link')}</span>*/}
        {/*  </div>*/}
        {/*  <div className="itemValue">*/}
        {/*    <input type="text" maxLength={1024} onChange={this.addChangeDocLink}*/}
        {/*           placeholder={React.language("placeholder.doc.link")}/>*/}
        {/*  </div>*/}
        {/*</div>*/}
        <div className="addItem remark">
          <div className="itemTitle">
            <span>
              <b>*</b>
              {React.language("select.release.standard.app")}
            </span>
          </div>
          <div className="itemValue">
            <div
              className="standardAppContent"
              onClick={this.openSelectAppPane}
            >
              {appIds.length === 0 ? (
                <div className="appsEmptyCont">
                  <div className="empty-cont">
                    <i className="icon-bsy-add"></i>
                    <span>
                      {React.language("select.release.standard.app.waterMark")}
                    </span>
                  </div>
                </div>
              ) : (
                <>
                  {appIds.map((res) => {
                    const app = appsMap[res];
                    return (
                      app && (
                        <div className="app-item" key={res}>
                          <div className="app-icon">
                            <div
                              className={`icon-backgroup color-cover-${app.style.color}`}
                            >
                              <div
                                className={`imgbg-bsy-app imgbg-bsy-app-${app.style.icon}`}
                              ></div>
                            </div>
                          </div>
                          <div className="app-name">{app.appname}</div>
                        </div>
                      )
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="addItem remark" style={{ marginBottom: 30 }}>
          <div className="itemTitle">
            <span>{React.language("project.remark")}</span>
          </div>
          <div className="itemValue">
            <textarea
              maxLength={1024}
              // onChange={this.addChangeProjectDesc}
              onBlur={this.addChangeProjectDesc}
              placeholder={React.language("project.remark.placeholder")}
            />
          </div>
        </div>
        <div className="projectTitle">{React.language("project.set")}</div>
        <div className="lineAddItem">
          <div className="itemTitle">
            <span>{React.language("version.number")}</span>
          </div>
          <div className="itemValue">
            <div className="item-line">
              <div className="line-title">
                {React.language("project.init.version")}
              </div>
              <div className="line-value">
                <span className="value-text">V1</span>
              </div>
            </div>
          </div>
        </div>
        <div className="lineAddItem">
          <div className="itemTitle">
            <span>{React.language("init.set")}</span>
          </div>
          <div className="itemValue">
            <div className="item-line">
              <div className="line-title">
                {React.language("select.user.install")}
              </div>
              <div className="line-value">
                <div className="value-radio-cont">
                  <div
                    className={`radio-item ${
                      userSelectType !== 1 ? "select" : ""
                    }`}
                    onClick={() => {
                      this.setState({ userSelectType: 2 });
                    }}
                  >
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <span>{React.language("allow.anyone.install")}</span>
                  </div>
                  <div
                    className={`radio-item ${
                      userSelectType === 1 ? "select" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.setState({ userSelectType: 1 });
                    }}
                  >
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <span>{React.language("only.allow.user.install")}</span>
                    {/*<span className="item-msg">{React.language('only.allow.user.install.msg')}</span>*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="item-line">
              <div className="line-title">
                {React.language("trial.time.after.first.installation")}
              </div>
              <div className="line-value">
                <div className="value-radio-cont">
                  <div
                    className={`radio-item ${
                      installTime !== 1 ? "select" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.setState({ installTime: 2 });
                    }}
                  >
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <div
                      className="selectTime"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      <input
                        type="number"
                        max="99999"
                        min="1"
                        onChange={this.addChangeDateTime}
                      />
                      <div className="timeType" onClick={this.selectTime}>
                        <span>{React.language(timeType)}</span>
                        <i className="icon-bsy-xia"></i>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`radio-item ${
                      installTime === 1 ? "select" : ""
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.setState({ installTime: 1 });
                    }}
                  >
                    <i className="icon-bsy-icondanxuananniu"></i>
                    <span>{React.language("not.limited")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddProjectContent;
